var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sip-agent',{attrs:{"ontIndex":_vm.uniqueOnt}}),_c('sip-user-addr',{attrs:{"ontIndex":_vm.uniqueOnt}}),_c('sip-user-info',{attrs:{"ontIndex":_vm.uniqueOnt}}),_c('sip-digitmap',{attrs:{"ontIndex":_vm.uniqueOnt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }